import { render, staticRenderFns } from "./PdfGallery.vue?vue&type=template&id=9da83a80&scoped=true"
import script from "./PdfGallery.vue?vue&type=script&lang=js"
export * from "./PdfGallery.vue?vue&type=script&lang=js"
import style0 from "./PdfGallery.vue?vue&type=style&index=0&id=9da83a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da83a80",
  null
  
)

export default component.exports